export enum ManualActionRequestSource{
    None = 0,
    CampaignTeam = 1,
    ClientRequest = 2,
}